import { render, staticRenderFns } from "./UiClose.vue?vue&type=template&id=185c05c8&scoped=true&lang=pug"
import script from "./UiClose.vue?vue&type=script&lang=js"
export * from "./UiClose.vue?vue&type=script&lang=js"
import style0 from "./UiClose.vue?vue&type=style&index=0&id=185c05c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185c05c8",
  null
  
)

export default component.exports